import type { SceneEditor, SceneViewer } from '@zakeke/zakeke-3d-core';

type TriggerViewer = Pick<SceneViewer, 'setTriggers'> & Partial<Pick<SceneEditor, 'getTriggersConfig' | 'setTriggersConfig'>>;

export const configureSceneTriggers = (viewer: TriggerViewer, enabled: boolean) => {
    if (enabled) return;

    // Gate the public engine entry point before loading: load events otherwise
    // execute during scene initialization. Keep stored definitions for round trips.
    const setTriggers = viewer.setTriggers.bind(viewer);
    viewer.setTriggers = () => setTriggers([]);
    if (viewer.getTriggersConfig) viewer.getTriggersConfig = () => [];
    if (viewer.setTriggersConfig) viewer.setTriggersConfig = () => {};
};
